import { Area } from "../../core/constants/area";
import { AvailableDocsModel, AvailableTemplateDocsModel, DocuSignDocModel, TransportAvailableDocsModel } from "./models/models";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DocuSignService {

    constructor(public httpClient: HttpClient) { }

    //==============================
    // GET METHODS
    //==============================

    getAvailableAgreements(): Observable<AvailableDocsModel[]> {
        const url = `${environment.dotNetApiUrl}/${Area.transportation}/docusign/getAvailableAgreements`;
        return this.httpClient.get<AvailableDocsModel[]>(url);
    }

    getContactRoles(companyId): Observable<AvailableDocsModel[]> {
        const url = `${environment.dotNetApiUrl}/${Area.core}/contact/GetContactRoleListsByDivisionKey?divisionKey=${companyId}`;
        return this.httpClient.get<AvailableDocsModel[]>(url);
    }

    getDocuments(companyId): Observable<DocuSignDocModel[]> {
        const url = `${environment.dotNetApiUrl}/${Area.transportation}/docusign/getDocuments?companyId=${companyId}`;
        return this.httpClient.get<DocuSignDocModel[]>(url);
    }

    //==============================
    // POST METHODS
    //==============================

    downloadTemplate(model: AvailableTemplateDocsModel[]): Observable<AvailableDocsModel[]> {
        const url = `${environment.dotNetApiUrl}/${Area.transportation}/docusign/DownloadDocument`;
        return this.httpClient.post<any[]>(url, model);
    }

    resendDocument(documentId): Observable<boolean> {
        const url = `${environment.dotNetApiUrl}/${Area.transportation}/docusign/ResendDocument?documentId=${documentId}`;
        return this.httpClient.post<boolean>(url, null);
    }

    resendTransportDocument(documentId): Observable<boolean> {
        const url = `${environment.dotNetApiUrl}/${Area.transportation}/docusign/ResendTransportDocument?documentId=${documentId}`;
        return this.httpClient.post<boolean>(url, null);
    }

    sendDocByNameToDocuSign(selectedDocs: AvailableDocsModel) {
        const url = `${environment.dotNetApiUrl}/${Area.transportation}/docusign/sendDocToDocuSignByName`;
        return this.httpClient.post<any[]>(url, selectedDocs);
    }

    sendDocsToDocuSign(selectedDocs: AvailableDocsModel[]) {
        const url = `${environment.dotNetApiUrl}/${Area.transportation}/docusign/sendDocsToDocuSign`;
        return this.httpClient.post<any[]>(url, selectedDocs);
    }

    sendTransportDocToDocuSign(selectedDocs: TransportAvailableDocsModel[]) {
        const url = `${environment.dotNetApiUrl}/${Area.transportation}/docusign/sendTransportDocToDocuSign`;
        return this.httpClient.post<any[]>(url, selectedDocs);
    }

    updateDocumentList(): Observable<AvailableDocsModel[]> {
        const url = `${environment.dotNetApiUrl}/${Area.transportation}/docusign/UpdateDocumentList`;
        return this.httpClient.post<any[]>(url, []);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/docusign/docusign.service.ts